import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { DashboardMfeComponent } from './dashboard-mfe.component';

export const routes: Routes = [
  {
    path: '',
    component: DashboardMfeComponent,
    data: {
      isMfe: true,
      module: 'home-dashboard',
      hideBreadcrumbs: true,
      hideModuleTitle: true,
      reuse: true
    },
    children: [
      {
        path: '**',
        component: DashboardMfeComponent,
        data: {
          isMfe: true,
          module: 'home-dashboard',
          hideBreadcrumbs: true,
          hideModuleTitle: true,
          reuse: true
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardMfeRoutingModule { }
